import React, { ReactElement } from "react";
import StarIcon from "../icons/StarIcon";

interface CardActionProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function CardGate({ onClick }: CardActionProps): ReactElement {
  return (
    <div className="px-2">
      <span className={` text-ce-gray-500 text-xxs pb-2`}>
        You have reached the limit of your free plan - Upgrade to Premium to
        proofread whole documents!
      </span>
      <button
        type="button"
        className="w-full bg-style-green-10 hover:bg-style-green-50 px-2 py-2 cursor-pointer rounded-md flex items-center"
        onClick={onClick}
      >
        <span className="mr-2">
          <StarIcon className="w-6 h-6" />
        </span>
        <span className={` text-ce-gray-500 text-sm font-bold`}>
          Upgrade to CE Premium &gt;
        </span>
      </button>
    </div>
  );
}

export default CardGate;
